import invert from 'lodash/invert'
import { CURATOR_MENU_SECTION } from "../../redux/slicers/admin/curatorMenuPreferencesSlicer";

export const MAX_RESOLUTION = 5000;
export const MIN_RESOLUTION = 1;

export const TEXTURE_MAP = {
  DIFFUSE:            0,  // for Select texture from gallery
  NORMAL:             1,  // for custom normal map
  ROUGHNESS:          2,  // for custom roughness map
  AMBIENTOCCLUSION:   3,  // for custom ocullsion map
  TRANSPARENCY:       4 , // for custom transparency map
  METALLIC:           5,  // for custom metallic map
}

export const TILING_TYPE = {
  TEXTURE: 0, // for texture tiling  
  MATERIAL: 1, 
  DEPTH: 2, // for normal tiling
  GLOSSY: 3, // for Glossy tiling
  TRANSPARENCY: 4, // for Transparency tiling
  AO: 5,
  METALLIC: 6,



  EMISSION: 999, // TODO: what is the real number of emission???
  OTHER: 1000,
}

export const GENERATE_MAP_TYPE = {
  [TILING_TYPE.DEPTH]: 'normal',
  [TILING_TYPE.AO]: 'ambientOcclusion',
  [TILING_TYPE.GLOSSY]: 'roughness',
}

export const TILING_TYPE_LABEL = {
  [TILING_TYPE.TEXTURE]: 'texture',
  [TILING_TYPE.MATERIAL]: 'material',
  [TILING_TYPE.DEPTH]: 'normal',
  [TILING_TYPE.GLOSSY]: 'glossy',
  [TILING_TYPE.TRANSPARENCY]: 'transparency',
  [TILING_TYPE.AO]: 'ao',
  [TILING_TYPE.METALLIC]: 'metallic',
}

export const CHANGED_MAP_PATHS_MAP = {
  texture: 'diffuseId',
  glossiness: 'roughnessId',
  normal: 'normalId',
  transparency: 'transparencyId',
  ao: 'AOId',
  metallic: "metallicId",
}

export const CHANGED_MAP_IDS__TEXTURE_MAP = {
  [TEXTURE_MAP.DIFFUSE]: 'diffuseId',
  [TEXTURE_MAP.NORMAL]: 'normalId',
  [TEXTURE_MAP.ROUGHNESS]: 'roughnessId',
  [TEXTURE_MAP.TRANSPARENCY]: 'transparencyId',
  [TEXTURE_MAP.METALLIC]: 'metallicId',
  [TEXTURE_MAP.AMBIENTOCCLUSION]: 'AOId',
}
export const CHANGED_MAP_PATHS__TEXTURE_MAP = {
  [TEXTURE_MAP.DIFFUSE]: 'diffusePath',
  [TEXTURE_MAP.NORMAL]: 'normalPath',
  [TEXTURE_MAP.ROUGHNESS]: 'roughnessPath',
  [TEXTURE_MAP.TRANSPARENCY]: 'transparencyPath',
  [TEXTURE_MAP.METALLIC]: 'metallicPath',
  [TEXTURE_MAP.AMBIENTOCCLUSION]: 'AOAOPathId',
}

export const TEXTURE_NAME_KEY = {
  DIFFUSE: 'diffuseName',
  NORMAL: 'normalMapName',
  ROUGHNESS: 'roughnessMapName',
  TRANSPARENCY: 'transparencyMapName',
  METALLIC: 'metallicMapName',
  AO: 'aoMapName',
}

export const TEXTURE_MAP__TEXTURE_NAME_KEY = {
  [TEXTURE_MAP.DIFFUSE]: TEXTURE_NAME_KEY.DIFFUSE,
  [TEXTURE_MAP.NORMAL]: TEXTURE_NAME_KEY.NORMAL,
  [TEXTURE_MAP.ROUGHNESS]: TEXTURE_NAME_KEY.ROUGHNESS,
  [TEXTURE_MAP.TRANSPARENCY]: TEXTURE_NAME_KEY.TRANSPARENCY,
  [TEXTURE_MAP.METALLIC]: TEXTURE_NAME_KEY.METALLIC,
  [TEXTURE_MAP.AMBIENTOCCLUSION]: TEXTURE_NAME_KEY.AO,
}

export const TEXTURE_NAME_KEY__TEXTURE_MAP = invert(TEXTURE_MAP__TEXTURE_NAME_KEY);



export const DIMENSION = {
  _2D: '2D',
  _3D: '3D',
}

export const UNITY_2D_VIEW_MODE = {
  TOP: 0,
  LEFT: 1,
  RIGHT: 2,
  FRONT: 3,
  BACK: 4,
}

export const CURSOR_MODE = {
  MOVE: 'MOVE',
  ROTATE: 'ROTATE',
  SCALE: 'SCALE',
  STYLE_ONLY: 'STYLE_ONLY',
}

export const TRANSFORM_SPACE_MODE = {
  GLOBAL: 0,
  LOCAL: 1,
}

export const MEASURE_UNIT = {
  INCHES: 1,
  FEET: 2,
  CM: 3,
  METER: 4,
}

export const MEASURE_UNITY_NAME_MAP = {
  [MEASURE_UNIT.INCHES]: 'inches',
  [MEASURE_UNIT.FEET]: 'feet',
  [MEASURE_UNIT.CM]: 'cm',
  [MEASURE_UNIT.METER]: 'meter',
}

export const AXIS = {
  X: 'X',
  Y: 'Y',
  Z: 'Z',
  ALL: 'All',
}

export const ROTATE_MODE = {
  GLOBAL: 'GLOBAL',
  X: 'X',
  Y: 'Y',
  Z: 'Z',
}

export const DECIMAL_NUM_COUNT = 2;

export const TILING_TEXTURE_MAP = {
  [TILING_TYPE.TEXTURE]: TEXTURE_MAP.DIFFUSE,
  [TILING_TYPE.DEPTH]: TEXTURE_MAP.NORMAL,
  [TILING_TYPE.GLOSSY]: TEXTURE_MAP.ROUGHNESS,
  [TILING_TYPE.TRANSPARENCY]: TEXTURE_MAP.TRANSPARENCY,
  [TILING_TYPE.METALLIC]: TEXTURE_MAP.METALLIC,
  [TILING_TYPE.AO]: TEXTURE_MAP.AMBIENTOCCLUSION,
}

export const TEXTURE_MAP_TO_TILING_TYPE = invert(TILING_TEXTURE_MAP);

export const TILING_MAP = {
  [TILING_TYPE.TEXTURE]: "_MainTex",
  [TILING_TYPE.GLOSSY]: "_SmoothnessMap",
  [TILING_TYPE.DEPTH]: "_BumpMap",
  [TILING_TYPE.TRANSPARENCY]: "_AlphaTexture",
  [TILING_TYPE.AO]: "_OcclusionMap",
  [TILING_TYPE.METALLIC]: "_MetallicGlossMap",
};

export const OBJECT_MOVE_MAX_METERS = 100; // when user selects single axis -> it's max he can move that object

export const TILING_NAME_MAP = {
  [TILING_TYPE.TEXTURE]: "texture",
  [TILING_TYPE.MATERIAL]: "material",
  [TILING_TYPE.DEPTH]: "normal",
  [TILING_TYPE.GLOSSY]: "glossiness",
  [TILING_TYPE.TRANSPARENCY]: "transparency",
  [TILING_TYPE.AO]: "ao",
  [TILING_TYPE.METALLIC]: "metallic",
  [TILING_TYPE.EMISSION]: "emission",
  [TILING_TYPE.OTHER]: "other",
}

export const REVERSE_TILING_MAP = invert(TILING_MAP)

export const PROPERTY_MAP = {
  texture: "_MainTex",
  glossiness: "_SmoothnessMap",
  normal: "_BumpMap",
  transparency: "_AlphaTexture",
  ao: "_OcclusionMap",
  metallic: "_MetallicGlossMap",
};

export const REVERSE_PROPERTY_MAP = invert(PROPERTY_MAP);

export const SELECTED_OBJECT_COUNT_STR = {
  NONE: 'NoneObject',
  SINGLE: 'SingleObject',
  MULTIPLE: 'MultipleObject',
}

export const UNITY_OBJECT_TYPE = {
  PROP: 'Prop',
  LIGHT: 'Light',
}

export const RP_TYPE = {
  RENDER: 'RENDER',
  PREVIEW: 'PREVIEW',
};

export const DEFAULT_CAMERA_BLUR_INTENSITY = 5; // when we select object this blur intensity is applied by default in unity so we need to reset camera blur intensity to this value

export const HIDDEN_SECTIONS = [CURATOR_MENU_SECTION.MORE, CURATOR_MENU_SECTION.AUTOMATION];

